<template>
    <div class="flex justify-between flex-wrap">
        <div class="text-hint w-16">{{ label }}:</div>
        <div class="w-auto">
            <div v-if="closed" class="text-hint w-auto">Closed</div>
            <div v-else-if="start && end">
                <span class="text-hint">{{
                    convertTo12HourFormat(start)
                }}</span>
                -
                <span class="text-hint">{{ convertTo12HourFormat(end) }}</span>
            </div>
            <div v-else>---</div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        convertTo12HourFormat(timeStr) {
            const hours = parseInt(timeStr.slice(0, 2), 10);
            const minutes = parseInt(timeStr.slice(2), 10);

            const twelveHourHours = ((hours + 11) % 12) + 1;
            const amPm = hours < 12 ? "AM" : "PM";

            return `${twelveHourHours}:${minutes
                .toString()
                .padStart(2, "0")} ${amPm}`;
        },
    },
    props: ["start", "end", "label", "closed"],
};
</script>
